import React, { useState } from 'react';
import {
  ButtonBase,
  Spinner,
  Stack,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { ContentCopyIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';
import DuplicatesModal from './DuplicatesModal';

type Props = {
  duplicatesData: Array<any>,
  intl: Object,
  isLoading: boolean,
  onNotAMatch: (id: string) => void,
  onMerge: (id: string, mergeData: Object) => void,
};

const DuplicatesCard = ({
  duplicatesData,
  intl,
  isLoading,
  onNotAMatch,
  onMerge,
}: Props) => {
  const [modalOpen, setModalOpen] = useState(false);

  const handleClick = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const duplicateCount = duplicatesData?.length || 0;

  return (
    <>
      <ButtonBase
        sx={{
          backgroundColor: 'transparent',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: '16px',
          color: 'text.primary',
          padding: 4,
          display: 'flex',
          width: '273px',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '32px',
          marginBottom: 2,
        }}
        onClick={handleClick}
        disabled={isLoading}
      >
        <Stack
          direction="column"
          alignItems="center"
          spacing={2}
          sx={{ alignSelf: 'stretch' }}
        >
          {isLoading ? (
            <Spinner />
          ) : (
            <>
              <ContentCopyIcon fontSize="xLarge" />
              <Typography align="center" variant="titleLarge">
                {intl.formatMessage({
                  id: 'App.TaskTab.DuplicatesCard.DuplicatesDetected',
                  defaultMessage: 'Duplicates Detected',
                })}
              </Typography>
              <Typography
                align="center"
                variant="titleLarge"
                color="primary.main"
              >
                {duplicateCount}
              </Typography>
            </>
          )}
        </Stack>
      </ButtonBase>

      <DuplicatesModal
        open={modalOpen}
        onClose={handleCloseModal}
        duplicatesData={duplicatesData}
        intl={intl}
        onNotAMatch={onNotAMatch}
        onMerge={onMerge}
      />
    </>
  );
};

export default DuplicatesCard;
